import { render, staticRenderFns } from "./CardStatusReadonly.vue?vue&type=template&id=7506e330"
import script from "./CardStatusReadonly.vue?vue&type=script&lang=js"
export * from "./CardStatusReadonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7506e330')) {
      api.createRecord('7506e330', component.options)
    } else {
      api.reload('7506e330', component.options)
    }
    module.hot.accept("./CardStatusReadonly.vue?vue&type=template&id=7506e330", function () {
      api.rerender('7506e330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CardStatusReadonly.vue"
export default component.exports